<template>
  <div class="card-header m-b-10">
    <form
      class="box-search"
      @reset.prevent="triggerFilter(false)"
      @submit.prevent="triggerFilter()"
    >
      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.lendingId"
          class="form-control f12 hc-37"
          placeholder="ID cho mượn"
        />
      </div>

      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.merchantInfo"
          class="form-control f12 hc-37"
          placeholder="Tên/Email merchant"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.deviceCategoryCode"
          :options="deviceOptions"
          placeholder="Tên thiết bị"
        />
      </div>

      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.deviceSerial"
          class="form-control f12 hc-37"
          placeholder="Mã serial"
        />
      </div>

      <div class="form-group">
        <SearchStaffManager v-model="fieldSearch.managerStaffId" />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.inventoryId"
          :options="inventoryOptions"
          placeholder="Tên kho"
        />
      </div>

      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.contractCode"
          class="form-control f12 hc-37"
          placeholder="Số HD/PL"
        />
      </div>

      <div class="form-group">
        <input
          type="text"
          v-model.trim="fieldSearch.receiptCode"
          class="form-control f12 hc-37"
          placeholder="Số phiếu thu"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.receiptStatus"
          :options="receiptStatusOption"
          placeholder="Trạng thái phiếu thu"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.additionalReceiptStatus"
          :options="additionalReceiptStatusOption"
          placeholder="Trạng thái phiếu thu thêm"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.refundStatus"
          :options="refundStatusOption"
          placeholder="Trạng thái phiếu hoàn"
        />
      </div>

      <div class="form-group">
        <select2-multiple-control
          v-model="fieldSearch.statuses"
          :options="statusLendingIdDeviceOption"
          placeholder="Trạng thái  ID cho mượn"
          :settings="{ placeholder: 'Trạng thái  ID cho mượn' }"
        ></select2-multiple-control>
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.statusTpvMonthTMinus2"
          :options="TPVStatusOption"
          placeholder="Trạng thái TPV-T2"
        />
      </div>

      <div class="form-group">
        <Select2
          v-model="fieldSearch.statusTpvMonthTMinus1"
          :options="TPVStatusOption"
          placeholder="Trạng thái TPV-T1"
        />
      </div>

      <div class="form-group">
        <DateRangePicker
          class="w-100"
          :ranges="false"
          @update="transformDate()"
          v-model="dateRange"
          :locale-data="Config.localeData"
        >
          <template v-slot:input="picker">
            <label
              v-if="picker.startDate && picker.endDate"
              style="min-width: 13.5em"
              class="text-center font-size-12 pt-1"
            >
              {{ picker.startDate | formatDate }} -
              {{ picker.endDate | formatDate }}
            </label>
            <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
              Ngày active
            </label>
          </template>
        </DateRangePicker>
      </div>

      <div class="form-group form-group-action action-h">
        <button type="submit" ref="submitButtonRef" class="pt-2 mr-2 btn btn-primary hc-37">
          <i class="bx bx-filter-alt"></i> Lọc
        </button>
        <button type="reset" class="pt-2 mr-2 btn btn-outline-light hc-37">
          <i class="bx bx-filter-alt"></i> Bỏ lọc
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { DeviceService } from '@/services/device.service'
  import { showMessErrorResponse } from '@/config/utils'
  import SearchStaffManager from './SearchStaffManager.vue'
  import moment from 'moment'

  const searchDefault = {
    lendingId: '',
    merchantInfo: '', // ten or email merchant
    deviceCategoryCode: '',
    deviceSerial: '',
    inventoryId: '',
    contractCode: '',
    receiptCode: '',
    receiptStatus: '',
    additionalReceiptStatus: '',
    refundStatus: '',
    statuses: '',
    statusTpvMonthTMinus2: '',
    statusTpvMonthTMinus1: '',
    managerStaffId: '',
  }
  export default {
    name: 'FilterLendDevice',
    components: {
      SearchStaffManager,
    },
    data() {
      return {
        Config,
        fieldSearch: { ...cloneDeep(searchDefault) },
        listDevices: [],
        listInventories: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
      }
    },
    computed: {
      deviceOptions() {
        return this.Config.getSearch(this.listDevices || [])
      },
      inventoryOptions() {
        return this.Config.getSearch(this.listInventories || [])
      },
      receiptStatusOption() {
        return this.Config.getSearch(this.Config.receiptStatus)
      },
      additionalReceiptStatusOption() {
        return this.Config.getSearch(this.Config.additionalReceiptStatus)
      },
      refundStatusOption() {
        return this.Config.getSearch(this.Config.statusRefund)
      },
      TPVStatusOption() {
        return this.Config.getSearch(this.Config.statusTpv)
      },
      statusLendingIdDeviceOption() {
        return this.Config.getSearch(this.Config.statusIDLend)
      },
    },
    async mounted() {
      await this.fetchDevices()
      await this.getListInventory()
    },
    methods: {
      triggerFilter(isFilter = true) {
        if (!isFilter) {
          this.fieldSearch = { ...cloneDeep(searchDefault) }
          this.dateRange = {
            startDate: null,
            endDate: null,
          }
        }
        const params = this.params()
        this.$emit('change', params)
      },
      params() {
        const body = {}
        Object.keys(this.fieldSearch).forEach(key => {
          const value = this.fieldSearch[key]
          if (
            value !== '' &&
            value !== null &&
            value !== undefined &&
            value !== '0' &&
            !(Array.isArray(value) && value.length === 0)
          ) {
            body[key] = value
          }
        })
        console.log('Filter params:', body)
        return body
      },

      transformDate() {
        if (!this.dateRange.startDate || !this.dateRange.endDate) {
          this.fieldSearch.activeDateFrom = null
          this.fieldSearch.activeDateTo = null
          return
        }
        this.fieldSearch.activeDateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.fieldSearch.activeDateTo = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },

      async fetchDevices() {
        try {
          const response = await DeviceService.typeDeviceConfig()

          if (response.success) {
            this.listDevices = response.data.map(e => {
              return {
                id: e.abbreviation,
                text: e.name,
              }
            })
          }
        } catch (error) {
          showMessErrorResponse(this, error, 3000)
        }
      },
      async getListInventory() {
        try {
          const response = await DeviceService.infoWarehouse()
          if (response.success) {
            this.listInventories = response.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          showMessErrorResponse(this, error, 3000)
        }
      },
    },
  }
</script>

<style scoped>
  .action-h {
    height: 41px;
  }
</style>
